<script lang="ts">
  import { Monitor, Moon, Sun } from "@lucide/svelte"
  import { _ } from "svelte-i18n"

  import { useAppearanceSvelte } from "@/runes/use-appearance.svelte"

  // Compact icon-only segmented control, mirroring the renderer's footer theme
  // toggle. "System" follows the OS preference; "Light"/"Dark" pin it. State +
  // persistence (localStorage `appearance` + the `.dark` class on <html>) live
  // in the shared useAppearanceSvelte rune, the same one the settings page uses.
  const appearance = useAppearanceSvelte()

  const options = [
    { value: "system", Icon: Monitor, labelKey: "settings.appearance.system" },
    { value: "light", Icon: Sun, labelKey: "settings.appearance.light" },
    { value: "dark", Icon: Moon, labelKey: "settings.appearance.dark" },
  ] as const
</script>

<div
  role="group"
  aria-label={$_("settings.appearance.label")}
  class="inline-flex items-center gap-0.5"
>
  {#each options as { value, Icon, labelKey } (value)}
    {@const active = appearance.value === value}
    <button
      type="button"
      onclick={() => appearance.update(value)}
      aria-pressed={active}
      title={$_(labelKey)}
      class={[
        "flex size-7 items-center justify-center rounded transition-colors",
        active
          ? "bg-muted text-foreground"
          : "text-[#706f6c] hover:text-[#1b1b18] dark:text-[#A1A09A] dark:hover:text-[#EDEDEC]",
      ].join(" ")}
    >
      <Icon class="size-4" aria-hidden="true" />
      <span class="sr-only">{$_(labelKey)}</span>
    </button>
  {/each}
</div>
